import { Locales } from "../enums/locales";
export const getOrdinalSuffix = (i, locale, data) => {
    if (locale === Locales.FR) {
        if (i === 1) {
            return i + (data?.frenchGender === "M" ? "er" : "ère");
        }
        if (i === 2) {
            return i + "nd";
        }
        return i + "ème";
    }
    if (locale === Locales.ES) {
        return i + "°";
    }
    if (locale === Locales.DE) {
        return i + ".";
    }
    const lastDigit = i % 10;
    const lastTwoDigits = i % 100;
    if (lastDigit === 1 && lastTwoDigits !== 11) {
        return i + "st";
    }
    if (lastDigit === 2 && lastTwoDigits !== 12) {
        return i + "nd";
    }
    if (lastDigit === 3 && lastTwoDigits !== 13) {
        return i + "rd";
    }
    return i + "th";
};
export const getDecimalSeparator = (locale) => {
    return locale === Locales.EN ? "." : ",";
};
export const getZeroAmountPlaceholder = (locale) => {
    return `0${getDecimalSeparator(locale)}00`;
};
export const isCurrencySymbolAfterAmount = (locale) => locale === Locales.FR || locale === Locales.DE;
export const formatAmountWithThousandsSeparators = (value, locale) => {
    if (locale === Locales.DE) {
        return value.toLocaleString("de-DE", { maximumFractionDigits: 2 });
    }
    return value.toLocaleString(getDecimalSeparator(locale) === "," ? "fr-CA" : "en-CA", { maximumFractionDigits: 2 });
};
